import { styled } from "@mui/material/styles"
import { ReactNode, useState } from "react"

import configLayout from "./ConfigLayout"
import { Navbar } from "./Navbar"
import { Sidebar } from "./Sidebar"

const { DRAWER_WIDTH, DRAWER_WIDTH_CLOSE, APPBAR_DESKTOP, APPBAR_MOBILE } = configLayout

interface IProps {
  children: ReactNode
  hasSideBar?: boolean
}

interface IMainStyle {
  open: boolean
  hasSideBar: boolean
}

const RootStyle = styled("div")({
  height: "100%",
  width: "100%",
  backgroundColor: "background.default",
  overflowX: "hidden",
})

const MainStyle = styled("main")<IMainStyle>(({ theme, open, hasSideBar }) => ({
  marginLeft: !hasSideBar ? 0 : open ? DRAWER_WIDTH : DRAWER_WIDTH_CLOSE,
  width: open ? `calc(100vw - ${DRAWER_WIDTH}px)` : `calc(100vw - ${DRAWER_WIDTH_CLOSE}px)`,
  height: `calc(100vh - ${APPBAR_DESKTOP}px)`,
  marginTop: APPBAR_DESKTOP,
  padding: theme.spacing(2, 2),
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.easeIn,
  }),
  [theme.breakpoints.down("sm")]: {
    marginLeft: 0,
    width: "100vw",
  },
  [theme.breakpoints.down("xs")]: {
    marginTop: APPBAR_MOBILE,
    height: `calc(100vh - ${APPBAR_MOBILE})`,
    width: "100%",
    padding: theme.spacing(2),
    margin: 0,
  },
}))

export const Layout = ({ children, hasSideBar = true }: IProps) => {
  const [open, setOpen] = useState(false)

  const toggleOpen = () => setOpen(state => !state)

  return (
    <RootStyle>
      <Navbar isOpenSidebar={open} onSidebar={toggleOpen} hasSideBar={hasSideBar} />
      {hasSideBar && <Sidebar open={open} onClose={toggleOpen} />}
      <MainStyle open={open} hasSideBar={hasSideBar}>
        {children}
      </MainStyle>
    </RootStyle>
  )
}
